import { useEffect, useState } from 'react';
import { getRomaneioData } from '../../services/Romaneio/romaneioService';
import { getDiscountData } from '../../services/Discounts/discountsService';

const usePopulateRomaneioForm = (show, romaneioId, setValue, reset, setIsReadOnlyInputs) => {
  const [errorMessage, setErrorMessage] = useState('');
  const [showErrorModal, setShowErrorModal] = useState(false);

  useEffect(() => {
    const fetchRomaneioData = async () => {
      try {
        if (romaneioId) {
          const data = await getRomaneioData(romaneioId);
          
          //readOnlyInputs
          setIsReadOnlyInputs.numberNF = data?.numberNF || null;
          setIsReadOnlyInputs.observations = data?.observations || null;
          setIsReadOnlyInputs.weightNF = data?.weightNF || null;
          setIsReadOnlyInputs.entryDate = data?.entryDate || null;
          setIsReadOnlyInputs.entryHour = data?.entryHour || null;
          setIsReadOnlyInputs.exitDate = data?.exitDate || null;
          setIsReadOnlyInputs.exitHour = data?.exitHour || null;
          setIsReadOnlyInputs.ardido = data?.ardido || null;
          setIsReadOnlyInputs.avariado = data?.avariado || null;
          setIsReadOnlyInputs.impureza = data?.impureza || null;
          setIsReadOnlyInputs.umidade = data?.umidade || null;
          setIsReadOnlyInputs.quebrado = data?.quebrado || null;
          setIsReadOnlyInputs.verde = data?.verde || null;
          setIsReadOnlyInputs.ratePerc = data?.ratePerc || null;

          setValue('entryDate', data?.entryDate);
          setValue('entryHour', data?.entryHour);

          if (data?.type === 'ENTRADA') {
            setValue('entry', true);
            setValue('exit', false);
          } else if (data?.type === 'SAIDA') {
            setValue('entry', false);
            setValue('exit', true);
          }
          
          setValue('harvestId', { id: data.harvest?.id, description: data.harvest?.description });
          setValue('licensePlate',{ licensePlate: data?.licensePlate });
          setValue('driverId', { id: data.driver?.id, name: data.driver?.oldId + ' - ' + data.driver?.name });
          setValue('lotId', { id: data.lot?.id, description: data.lot?.description });
          setValue('originPersonId', { id: data.originPerson?.id, name: data.originPerson?.oldId + ' - ' + data.originPerson?.name });
          setValue('destinyPersonId', { id: data.destinyPerson?.id, name: data.destinyPerson?.name });
          setValue('farmId', { id: data.farm?.id, name: data.farm?.name });
          setValue('siloId', { id: data.silo?.id, name: data.silo?.name });
          setValue('productId', { id: data.product?.id, description: data.product?.description });
          setValue('numberNF', data?.numberNF);
          setValue('weightNF', (data?.weightNF));
          setValue('balance', (data?.balance));
          setValue('observations', data?.observations);

          if(data?.discount) {
            const discounts = await getDiscountData(data.discount?.id);
            setValue('discountId', { id: data.discount?.id, description: data.discount?.description, discount: discounts });
          }

          setValue('oldId', data?.oldId);
          setValue('exitDate', data?.exitDate);
          setValue('exitHour', data?.exitHour);
          setValue('tare', (data?.tare));
          setValue('ardido', data?.ardido);
          setValue('ardidoWeight', (data?.ardidoWeight));
          setValue('avariado', data?.avariado);
          setValue('avariadoWeight', (data?.avariadoWeight));
          setValue('impureza', data?.impureza);
          setValue('impurezaWeight', (data?.impurezaWeight));
          setValue('umidade', data?.umidade);
          setValue('umidadeWeight', (data?.umidadeWeight));
          setValue('quebrado', data?.quebrado);
          setValue('quebradoWeight', (data?.quebradoWeight));
          setValue('verde', data?.verde);
          setValue('verdeWeight', (data?.verdeWeight));
          setValue('ratePerc', data?.ratePerc);
          setValue('rateKg', (data?.rateKg));
          setValue('totalWeight', (data?.totalWeight));
          setValue('totalDiscounts', (data?.totalDiscounts));
          setValue('total', (data?.total));
          setValue('active', data?.active);
          setValue('reactivationForbidden', Boolean(data?.reactivationForbidden));

          if (data?.typeRate === 'BRUTO') {
            setValue('grossWeight', true);
            setValue('netWeight', false);
          } else if (data?.typeRate === 'LIQUIDO') {
            setValue('grossWeight', false);
            setValue('netWeight', true);
          }
        }
      } catch (error) {
        setErrorMessage(error.message || 'Erro ao buscar dados do romaneio.');
        setShowErrorModal(true);
      }
    };

    if (show && romaneioId) {
      fetchRomaneioData();
    } else if (!show) {
      reset();
    }
  }, [show, romaneioId, setValue, reset, setIsReadOnlyInputs]);

  return {
    errorMessage,
    showErrorModal,
    setShowErrorModal,
  };
};

export default usePopulateRomaneioForm;